import React, { useEffect, useState } from 'react';
import connect from 'Shared/connect';
import currentPageIsOrderConfirmation from '../Checkout/Pages/OrderConfirmation/current-page-is-order-confirmation';
const CustomVariables = ({ currentUser, currentPage }) => {
    const unknownValue = "unknown";
    const [orderId, setOrderId] = useState(unknownValue);
    useEffect(() => {
        if (currentPageIsOrderConfirmation(currentPage)) {
            setOrderId(currentPage.models.map((x) => x.orderNumber).join(","));
        }
        SetCustomVariables();
    });
    const SetCustomVariables = () => {
        Object.assign(window, { getFeedback: {
                customerId: !!currentUser && !!currentUser.customerId ? currentUser.customerId : unknownValue,
                isLoggedIn: !!currentUser.isLoggedIn ? "yes" : "no",
                customerType: !!currentUser.customerType ? currentUser.customerType : unknownValue,
                marketSegment: !!currentUser.trackingUser && !!currentUser.trackingUser.customerType ? currentUser.trackingUser.customerType : unknownValue,
                storageId: !!currentUser.storeId && !!currentUser.isLoggedIn ? currentUser.storeId : unknownValue,
                orderId: orderId
            } });
    };
    return (React.createElement("div", { style: { display: 'none' }, id: "CustomVariables" },
        React.createElement("input", { type: "hidden", id: "customerId", name: "customerId", value: !!currentUser && !!currentUser.customerId ? currentUser.customerId : unknownValue }),
        React.createElement("input", { type: "hidden", id: "isLoggedIn", name: "isLoggedIn", value: !!currentUser.isLoggedIn ? "yes" : "no" }),
        React.createElement("input", { type: "hidden", id: "customerType", name: "customerType", value: !!currentUser.customerType ? currentUser.customerType : unknownValue }),
        React.createElement("input", { type: "hidden", id: "marketSegment", name: "marketSegment", value: !!currentUser.trackingUser && !!currentUser.trackingUser.customerType ? currentUser.trackingUser.customerType : unknownValue }),
        React.createElement("input", { type: "hidden", id: "storageId", name: "storageId", value: !!currentUser.storeId && !!currentUser.isLoggedIn ? currentUser.storeId : unknownValue }),
        React.createElement("input", { type: "hidden", id: "orderId", name: "orderId", value: orderId })));
};
export default connect(state => ({
    currentUser: state.currentUser,
    currentPage: state.currentPage,
}))(CustomVariables);
